export default __webpack_public_path__ + "static/media/printed-digital.875aa4cb.png";